import { useTranslation } from "react-i18next";
import ResetPasswordForm from "@/components/forms/resetPasswordForm";
import { useEffect, useState } from "react";
import { api } from "@/helper/api";
import ResetEmailForm from "@/components/forms/resetEmailForm";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useErrorModal } from "@/components/forms/errorHandling/useErrorModal";
import RestrictedPage from "@/consumer/restrictedPage";
import UserSettingsForm from "@/components/forms/userSettingsForm";
import styles from "@/routes/userSettings.module.css";
import UserSettings2fa from "@/components/forms/usersettings2fa";
import LanguageSettingsForm from "@/components/forms/languageSettingsForm";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";
import MailPreferencesForm from "@/components/mailTemplate/mailPreferencesForm";

export default function UserSettings() {
  const isAdmin = window.location.hostname.split(".")[0] === "admin";
  const [userInfos, setUserInfos] = useState<any>([]);
  const { handleError, errorModal } = useErrorModal();

  const { t } = useTranslation();

  const getLoggedInUserData = () => {
    api.genericApiRequest({
      entity: "me",
      method: "get",
      successHandler: (res: any) => {
        const data = res.data;
        setUserInfos(data);
      },
      failHandler: (error: any) => {
        handleError(error);
      },
    });
  };

  useEffect(() => {
    getLoggedInUserData();
  }, []);

  const userName = [userInfos.first_name, userInfos.last_name]
    .filter(Boolean)
    .join(", ");
  const heading = userName
    ? `${t("user_profile")} - ${userName}`
    : t("user_profile");
  usePageHeading(heading);

  return (
    <RestrictedPage permissionRequired="frontend_view_user_setting">
      <Grid container rowSpacing={"1rem"} className={styles.container}>
        <Grid item xs={12}>
          <ResetEmailForm email={userInfos.email} userId={userInfos.user_id} />
        </Grid>
        <Grid item xs={12}>
          <ResetPasswordForm />
        </Grid>
        <Grid item xs={12}>
          <UserSettingsForm userInfos={userInfos} />
        </Grid>
        <Grid item xs={12}>
          <LanguageSettingsForm
            userInfos={userInfos}
            onDataChange={getLoggedInUserData}
          />
        </Grid>
        <Grid item xs={12}>
          <UserSettings2fa userInfos={userInfos} />
        </Grid>
        {isAdmin && (
          <Grid item xs={12}>
            <Accordion TransitionProps={{ unmountOnExit: true }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{t("mail_preferences_title")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <MailPreferencesForm />
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
      </Grid>
      {errorModal}
    </RestrictedPage>
  );
}
